module.exports = __webpack_public_path__ + "2020celebration/img/s5.15afc989.png";